<template>
  <div id="app" class="full-space">
    
    <router-view/>

  </div>
</template>
<script defer src="https://use.fontawesome.com/releases/v5.3.1/js/all.js"></script>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #d7311c;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$navbar-left: 90px;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "assets/scss/main.scss";
@import "assets/scss/multselect.scss";
@import "assets/scss/Glyphter.css";
@import "assets/scss/styles.css";
@import "assets/scss/metrics.scss";
@import "assets/scss/ajustes.scss";
@import "assets/scss/corretor.scss";
@import "assets/scss/aluno.scss";
@import "assets/scss/navbar.scss";
@import "assets/scss/paineis.scss";
@import "assets/scss/perfil.scss";
</style>
